<template>
  <ul class="pagination">
    <li class="page-item" :class="{ disabled: page === 1 }">
      <a class="page-link icon icon-page-arrow" @click.prevent="prevPage"></a>
    </li>
    <li v-for="num in firstPages" :key="num" class="page-item" :class="{ active: num === page }">
      <a class="page-link" @click.prevent="changePageByClick(num)">{{ num }}</a>
    </li>
    <template v-if="lastPages">
      <li class="page-item disabled">
        <span class="page-link ellipsis">......</span>
      </li>
      <li v-for="num in lastPages" :key="num" class="page-item" :class="{ active: num === page }">
        <a class="page-link" @click.prevent="changePageByClick(num)"> {{ num }}</a>
      </li>
    </template>
    <li class="page-item" :class="{ disabled: page === pageCount }">
      <a class="page-link icon icon-page-arrow right-turn" @click.prevent="nextPage"></a>
    </li>
    <template v-if="amountElements">
      <div class="amount-element">
        <p>{{ $t('src/components/paginator.8873') }}</p>
        <li
          v-for="count in this.showBy"
          :key="count"
          class="page-item"
          :class="{ active: count === perPage }"
        >
          <a class="page-link" @click.prevent="changeShowCount(count)">{{ count }}</a>
        </li>
      </div>
    </template>
  </ul>
</template>

<script>
import('@/styles/elements/pagination.less')

export default {
  name: 'PaginatorComponent',
  model: {
    prop: 'page'
  },
  props: {
    total: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    amountElements: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => ({
    countToShow: 5,
    showBy: [10, 25, 50]
  }),
  computed: {
    halfPageCount() {
      return Math.ceil(this.pageCount / 2)
    },
    pageCount() {
      return Math.ceil(this.total / this.perPage)
    },
    firstPages() {
      if (this.halfPageCount <= this.countToShow) {
        return this.pageCount
      }
      let pages = [],
        startPage
      if (this.page > this.halfPageCount) {
        return [1]
      } else if (this.page > 1) {
        startPage = this.page > 2 ? this.page - 2 : this.page - 1
      } else {
        startPage = this.page
      }
      for (let i = 0; i < this.countToShow; i++) {
        pages.push(startPage + i)
      }
      return pages
    },
    lastPages() {
      if (this.halfPageCount <= this.countToShow) {
        return null
      }
      let pages = [],
        startPage
      if (this.page <= this.halfPageCount) {
        return [this.pageCount]
      } else if (this.page === this.pageCount) {
        startPage = this.page
      } else {
        startPage = this.page === this.pageCount - 1 ? this.page + 1 : this.page + 2
      }

      for (let i = 0; i < this.countToShow; i++) {
        pages.push(startPage - i)
      }
      return pages.reverse()
    },
    queryPage() {
      return !this.$route.query ? null : this.$route.query.page
    }
  },
  watch: {
    queryPage() {
      this.updatePageWithQuery()
    },
    page() {
      this.changePageInRoute(this.page)
    }
  },
  mounted() {
    this.updatePageWithQuery()
  },
  methods: {
    updatePageWithQuery() {
      if (this.queryPage) {
        this.changePage(this.queryPage)
      } else {
        this.changePage(1)
      }
    },
    changePageByClick(page) {
      this.changePageInRoute(page)
      this.changePage(page)
    },
    changePageInRoute(page) {
      let query = Object.assign({}, this.$route.query, { page: page })
      if (page === 1) {
        delete query.page
      }
      this.$router.push({
        query: query
      })
    },
    changePage(page) {
      this.$emit('input', Number(page))
    },
    prevPage() {
      this.changePage(this.page - 1)
    },
    nextPage() {
      this.changePage(this.page + 1)
    },
    changeShowCount(perPage) {
      this.$emit('change:count', Number(perPage))
    }
  }
}
</script>
